<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M15.8366 9.25C16.2508 9.25 16.5866 9.58579 16.5866 10C16.5866 10.4142 16.2508 10.75 15.8366 10.75C11.9477 10.75 8.05881 10.75 4.16992 10.75C3.75571 10.75 3.41992 10.4142 3.41992 10C3.41992 9.58579 3.75571 9.25 4.16992 9.25C8.05881 9.25 11.9477 9.25 15.8366 9.25Z"
    fill="currentColor" />
</svg>